
import { Component, Vue } from "nuxt-property-decorator";

@Component
export default class ExpandablePriceInfo extends Vue {
  isExpanded = false;

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}
